import { Button, Flex, IconButton, Menu, MenuButton, MenuItem, MenuList } from "@chakra-ui/react";
import { LocalDate, Month } from "@js-joda/core";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { range } from "../../utils";
import { CustomHeaderParams } from "./DatePickerJsJodaAdapter";

function toYear(localDate: LocalDate) {
  return localDate.year();
}

function toMonthName(month: Month) {
  return {
    [Month.JANUARY.ordinal()]: "January",
    [Month.FEBRUARY.ordinal()]: "February",
    [Month.MARCH.ordinal()]: "March",
    [Month.APRIL.ordinal()]: "April",
    [Month.MAY.ordinal()]: "May",
    [Month.JUNE.ordinal()]: "June",
    [Month.JULY.ordinal()]: "July",
    [Month.AUGUST.ordinal()]: "August",
    [Month.SEPTEMBER.ordinal()]: "September",
    [Month.OCTOBER.ordinal()]: "October",
    [Month.NOVEMBER.ordinal()]: "November",
    [Month.DECEMBER.ordinal()]: "December",
  }[month.ordinal()];
}

function shouldDisplayNextMonth(customHeaderCount: number, totalMonthsShown: number | undefined) {
  return totalMonthsShown === undefined || totalMonthsShown - 1 === customHeaderCount;
}

interface Props extends CustomHeaderParams {
  totalMonthsShown?: number;
  pickerYears?: [number, number];
}

const DatePickerHeader = (props: Props) => {
  const canMoveToNextMonth = shouldDisplayNextMonth(
    props.customHeaderCount,
    props.totalMonthsShown
  );

  const firstYear = props.pickerYears?.[0] ?? props.monthDate.year() - 1;
  const yearsMenuItems: number[] = [
    ...range(props.pickerYears !== undefined ? props.pickerYears[1] - props.pickerYears[0] : 4).map(
      (i) => firstYear + i
    ),
  ];

  return (
    <Flex>
      {props.customHeaderCount === 0 && (
        <IconButton
          aria-label="Previous month"
          icon={<FaChevronLeft />}
          variant="text"
          onClick={props.decreaseMonth.bind(this)}
        />
      )}
      <Flex alignItems="center" flex={1} gap={2} justifyContent="center">
        {/* isLazy on both menus: without it every month and every year is mounted
            as a chakra MenuItem the moment the calendar opens. With the default
            1900..currentYear range that is ~140 menu items per open, which is
            enough to visibly delay the popup. */}
        <Menu isLazy={true}>
          <MenuButton as={Button} variant="ghost">
            {toMonthName(props.monthDate.month())}
          </MenuButton>
          <MenuList minWidth="fit-content">
            {Month.values().map((month) => (
              <MenuItem
                key={month.ordinal()}
                fontSize="md"
                onClick={() => props.changeMonth(month)}
              >
                {toMonthName(month)}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
        <Menu isLazy={true}>
          <MenuButton as={Button} variant="ghost">
            {toYear(props.monthDate)}
          </MenuButton>
          <MenuList maxHeight="xs" minWidth="fit-content" overflowY="scroll">
            {yearsMenuItems.map((year) => (
              <MenuItem key={year} fontSize="md" onClick={() => props.changeYear(year)}>
                {year}
              </MenuItem>
            ))}
          </MenuList>
        </Menu>
      </Flex>
      {canMoveToNextMonth && (
        <IconButton
          aria-label="Next month"
          icon={<FaChevronRight />}
          variant="text"
          onClick={props.increaseMonth.bind(this)}
        />
      )}
    </Flex>
  );
};

export default DatePickerHeader;
